import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible'
import './permission'
import { post, get, patch, put } from './utils/request'
import './icons' // icon
import scrolltop from '@/directive/backToTop.js'

import components from './components/index'

// 全局定义请求方法
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$patch = patch
Vue.prototype.$put = put
/* eslint-disable no-unused-vars */
// import vConsole from 'vconsole'
// new vConsole()
Vue.use(scrolltop) // 鼠标移出事件，解决ios微信input,textarea等失去焦点时页面不回弹
Vue.use(Vant)
Vue.use(components)
Vue.config.productionTip = false
console.log(process.env.VUE_APP_BASE_URL)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
